import { ref } from 'vue'

export const dataLoaded = ref(0)
